import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-[#001a2d] py-12 px-4" data-id="element-271">
      <div className="max-w-5xl mx-auto" data-id="element-272">
        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-12 text-center" data-id="element-273">
          <div data-id="element-274">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-275">
              +300
            </div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-276">
              profes confían
            </div>
          </div>
          <div data-id="element-277">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-278">
              6+6
            </div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-279">
              Tomos + Bonos
            </div>
          </div>
          <div data-id="element-280">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-281">
              4.9/5
            </div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-282">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-283">
            <div className="text-4xl sm:text-5xl font-black text-white" data-id="element-284">🌎</div>
            <div className="text-[#00B4D8] text-sm font-semibold mt-1" data-id="element-285">
              Mundial
            </div>
          </div>
        </div>

        {/* Micro testimonials */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-286">
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-287">
            <div className="w-10 h-10 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-288">
              MR
            </div>
            <div data-id="element-289">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-290">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-291">
                "Organicé todo el año en una tarde. Nunca más improviso."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-292">
                — Martín R. | Profesor de Club
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-293">
            <div className="w-10 h-10 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-294">
              CS
            </div>
            <div data-id="element-295">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-296">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-297">
                "Mis alumnos juniors mejoraron de nivel por primera vez en
                años."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-298">
                — Carolina S. | Entrenadora en Academia
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3 bg-black/40 border border-[#00B4D8]/20 rounded-xl p-4" data-id="element-299">
            <div className="w-10 h-10 rounded-full bg-[#00B4D8]/20 flex items-center justify-center text-[#00B4D8] font-black text-sm flex-shrink-0" data-id="element-300">
              DV
            </div>
            <div data-id="element-301">
              <div className="text-[#00B4D8] text-xs mb-1" data-id="element-302">⭐⭐⭐⭐⭐</div>
              <p className="text-white text-sm font-medium" data-id="element-303">
                "Antes tardaba 1 hora en armar una clase táctica. Ahora 5
                minutos."
              </p>
              <p className="text-gray-300 text-xs mt-1" data-id="element-304">
                — Diego V. | Profesor Independiente
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}